import React from "react";
import { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";

import SocialMedia from "../SocialMedia";
import TypeWriter from "./TypeWriter";
import BIRDS from 'vanta/dist/vanta.net.min'
import About from "../About/About";
import Projects from "../Projects/Projects";

function Home({tech, home,about,contact,project}) {
  // const home = useRef(null)
  // console.log(home)

  const [vantaEffect, setVantaEffect] = useState(0)
  

  useEffect(() => {
    if (!vantaEffect) {
      setVantaEffect(
        BIRDS({
          el: home.current,
        
          mouseControls: true,
          touchControls: true,
          gyroControls: false,
          minHeight: 200.00,
          minWidth: 200.00,
          scale: 1.00,
          scaleMobile: 1.00,
          color: 0x4666fc,
          backgroundColor: 0x0,
          points: 20.00,
          maxDistance: 24.00,
          spacing: 20.00
        })
      )
    }
    return () => {
      if (vantaEffect) vantaEffect.destroy()
    }
  }, [vantaEffect,home])
  




  return (
    <section >
    <section style={{minHeight:"100vh",maxHeigth:"100vh" ,backgroundColor:"black",border:"",display:"grid",alignItems:"center",justifyContent:"center"}} ref={home}  >
      <Container fluid className="home-section" id="home"  style={{border:"",color:"white"}}  >
        {/* <Container className="home-content" style={{border:"1px solid blue"}}  > */}
          {/* <Row  style={{border:"1px solid yellow"}}> */}
            {/* <Col md={10} className="home-header" style={{margin:"auto",textAlign:"center",border:"1px solid green"}}  > */}
              {/* <h1 style={{ paddingBottom: 15 }} className="heading">
                Hi There!{" "}
                <span className="wave" role="img" aria-labelledby="wave">
                  👋🏻
                </span>
              </h1> */}

              <h1 className="heading-name">
               <strong >Hello</strong>, I'M
                <strong style={{backgroundColor:"#3765ffd8",padding:"5px",marginLeft:"5px",color:"black"}} >Altaf Ali Baig</strong>
              </h1>

              

              <div className="heading-type">
                <TypeWriter />
              </div>
            {/* </Col> */}

            {/* <Col md={5}>
              <img src={myImg} className="profile-pic" alt="avatar" />
            </Col> */}
          {/* </Row> */}
        {/* </Container> */}
      </Container>
     
      
      
    </section>

    <Container ref={about} style={{maxWidth:"100%",minWidth:"100%"}} >
        <About tech={tech} />
    </Container>


    <Container ref={project} style={{maxWidth:"100%",minWidth:"100%"}} >
        <Projects />
    </Container>


    <Container fluid className="home-about-section" id="about"ref={contact} style={{maxWidth:"100%",minWidth:"100%",backgroundColor:"#161515"}} >
        <Container>
          <Row>
            <Col md={12} className="home-about-social">
              <h1 className="text-rainbow-animation2">
              <strong>Get in Touch</strong>
              </h1>
              <p>
                {" "}
                Whether you want to get in touch, or talk about a project
                collaboration.
                <br />
                <strong>Feel free to connect with me</strong>
              </p>
              </Col>
              </Row>
            
            
          
        </Container>
        <SocialMedia />
      </Container>

    
    
    </section>
  );
}

export default Home;
